import { Component, Input, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { PopoverInput } from './base/popover-input';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import * as moment from 'moment';


@Component({
    selector: 'popover-date',
    template: require('./popover-date.component.html')

})
export class PopoverDateComponent extends PopoverInput  {

	constructor() { super() }

	@Input() format: string = "yyyy-MM-dd";

	@Input() showWeek: boolean = false;

	@ViewChild('datepicker') datepicker: any;

	@Input() kind: "" | "yearweek" | "date-yearweek" = "";

	model: any = { date: { year: null, month: null, day: null } };

	myOptions: INgxMyDpOptions = {
		appendSelectorToBody: false,
		showSelectorArrow: false,
		dateFormat: 'yyyy-mm-dd',
		firstDayOfWeek: 'mo',
		showTodayBtn: true,
		showWeekNumbers: true,
		sunHighlight: true,
		closeSelectorOnDateSelect: false,
		closeSelectorOnDocumentClick: false	
	
	};

	onShow() {
		console.log("popover-date::onShow");
		super.onShow();
		setTimeout(() => this.datepicker.openCalendar(), 100);
	}


	onSave(event) {
		console.log("popover-date::onSave");
		this.datepicker.closeCalendar();
		super.onSave(event);
	}

	onClear() {
		console.log("popover-date::onClear");
		this.datepicker.closeCalendar();
		this.model = { date: { year: null, month: null, day: null } };
		this.dirtyValue = null;
		setTimeout(() => this.datepicker.openCalendar());
	}

	onCancel() {
		console.log("onCancel");
		this.datepicker.closeCalendar();
		const d = moment(this.originalValue);
		this.model = { date: { year: d.year(), month: d.month() + 1, day: d.date() } };

	}

	onDateChanged(event) {

		if (!!event && !!event.formatted) {
			this.dirtyValue = event.formatted + "T00:00:00";
		}
	}


	valueChanged() {

		const d = moment(this.originalValue);
		this.model = { date: { year: d.year(), month: d.month() + 1, day: d.date() } };

	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-date.component.ts